/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(11 11)" _stroke="#00272E" stroke-width="1.1"><path pid="0" d="M0 11L11 0"/><path pid="1" d="M11 11L0 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/delete.js